/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Task_Deadline_Due_SoonInputs */

const en_task_deadline_due_soon = /** @type {(inputs: Task_Deadline_Due_SoonInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Due in ${i?.count} day`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Due in ${i?.count} days`);
	return /** @type {LocalizedString} */ ("task_deadline_due_soon");
};

const pt_br2_task_deadline_due_soon = /** @type {(inputs: Task_Deadline_Due_SoonInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Vence em ${i?.count} dia`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Vence em ${i?.count} dias`);
	return /** @type {LocalizedString} */ ("task_deadline_due_soon");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Due in {count} day" |
* | "other" | "Due in {count} days" |
*
* @param {Task_Deadline_Due_SoonInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_deadline_due_soon = /** @type {((inputs: Task_Deadline_Due_SoonInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Deadline_Due_SoonInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_deadline_due_soon(inputs)
	return pt_br2_task_deadline_due_soon(inputs)
});